<template>
    <router-view></router-view>
</template>

<script>
    export default {
        
    }
</script>


<style>
    @import url("./assets/css/style.css");

    @font-face {
        font-family: "google-sans";
        src: url("./fonts/google-sans.woff2");
    }

    @font-face {
        font-family: "firago";
        src: url("./fonts/FiraGO-Regular.otf");
    }

    * {
        box-sizing: border-box;
        font-family: "firago" !important;
    }
</style>